import { BaseZenputCollection, BaseZenputModel, Paginator } from '../../backbone-unorganized/shared/forms';

const DeploymentFlagModel = BaseZenputModel.extend({
    idAttribute: 'key'
});

const DeploymentFlagCollection = BaseZenputCollection.extend({
    model: DeploymentFlagModel,
    url: '/api/v3/flags/deployment/',
    valueKey: 'value',
    cache_enabled: true,
    cache_key: 'deployment_flags',
    paginator: null,

    initialize: function (_, options) {
        if (options && options.tests) {
            this.valueKey = 'test_value';
        }

        if (!this.paginator) {
            this.paginator = new Paginator();
        }
    },
    fetch: function (options = {}) {
        const keys = this.pluck('key').join(',');
        options.data = {
            keys
        };

        return this.constructor.__super__.fetch.call(this, options);
    },
    parse: function (response) {
        return response.data?.map(({ key, value }) => ({ ...(this.get(key)?.toJSON() || { key }), value }));
    },

    get_flag: function (flagName) {
        const model = this.findWhere({ key: flagName });
        if (!model) {
            $f.mobile.logging.log_error(`Flag "${flagName}" doesn't exist`, { flags: this.toJSON() }, true);
            return false;
        }
        return model.get(this.valueKey) ?? model.get('default_value') ?? false;
    }
});

export default DeploymentFlagCollection;
